import { UpsellContext, UpsellOffer } from '@/entities/pricing';

export const getUpsellAnalytics = (context: UpsellContext, surface: string, offer?: UpsellOffer) => ({
  currentInterval: context.interval,
  currentPlan: context.currentPlan.name,
  grid: context.grid,
  offer: offer?.kind ?? 'none',
  surface,
  targetPlan: offer?.plan.name,
  targetPriceId: offer?.price.id,
});
